module.exports = __webpack_public_path__ + "img/AE5005-P32.e412ab3f.jpg";